import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { alpha, styled } from '@mui/material/styles';

const StyledCarousel = styled(Carousel)(({ theme }) => ({
  '&.CCarouselContainer': {
    height: '100%',
    width: '100%',
    position: 'static',
  },
  '& .CCarouselItem': {
    height: 'auto',
    alignItems: 'stretch', // Ensure items stretch to fill container
    width: '100%',
    padding: theme.spacing(0, 1, 0.1, 1),
    '& > .MuiGrid-container': {
      height: '100%',
    },
    '& > .MuiBox-root ': {
      height: '100%',
    },
    '&:first-child': {
      padding: theme.spacing(0, 1, 0.1, 0),
    },
    '&:last-child': {
      padding: theme.spacing(0, 0, 0.1, 1),
    },
    '&.CCarouselSingleItem': {
      padding: '0',
    },
  },
  '& .react-multi-carousel-track ': {
    height: '100%',
  },
  '& .CArrow': {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: theme.spacing(5.75),
    height: theme.spacing(5.75),
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    border: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
    '&.CArrowLeft': {
      left: theme.spacing(3),
    },
    '&.CArrowRight': {
      right: theme.spacing(3),
    },
    '& .CArrowIcon': {
      fontSize: theme.typography.pxToRem(22),
      color: theme.palette.common.white,
    },
  },
  '& .CDots': {
    bottom: theme.spacing(1),
    '& .react-multi-carousel-dot--active': {
      '& button': {
        backgroundColor: theme.palette.common.white,
      },
    },
    '& button': {
      border: 0,
      backgroundColor: alpha(theme.palette.common.white, 0.25),
      width: theme.spacing(1),
      height: theme.spacing(1),
    },
  },
  '&.CArrowOutside': {
    '& .CArrow': {
      top: '35%',
      '&.CArrowRight': {
        right: theme.spacing(-8),
        [theme.breakpoints.down('xl')]: {
          right: theme.spacing(-7),
        },
        [theme.breakpoints.down('lg')]: {
          right: theme.spacing(1.5),
        },
      },
      '&.CArrowLeft': {
        left: theme.spacing(-8),
        [theme.breakpoints.down('xl')]: {
          left: theme.spacing(-7),
        },
        [theme.breakpoints.down('lg')]: {
          left: theme.spacing(1),
        },
      },
    },
  },
}));

export default StyledCarousel;
